import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import classNames from 'classnames/bind';
import { array, bool, func, node, object, shape, string } from 'prop-types';
import { TextBase } from "../../../internal/TextBase";
import Radio from '../../../Radio';
import { methodType } from '../../constants';
import { cardExpirationValidation, cardHolderValidation, cardNumberValidation, cardsWithIcons, cvcValidation, detectCardType, getTextField, normalizeCVV } from '../../helpers';
import { Card } from '../Card';
import styles from './Fields.css';
var cx = classNames.bind(styles);

var getCardIcons = function getCardIcons() {
  return /*#__PURE__*/React.createElement("span", null, cardsWithIcons.map(function (card, index) {
    return /*#__PURE__*/React.createElement("span", {
      key: "icon_".concat(index + 1),
      className: cx('new-card-icon')
    }, card.icon);
  }));
};

export var Fields = function Fields(_ref) {
  var mobile = _ref.mobile,
      messages = _ref.messages,
      disabled = _ref.disabled,
      cards = _ref.cards,
      card = _ref.card,
      newCard = _ref.newCard,
      themeRadio = _ref.themeRadio,
      method = _ref.method,
      form = _ref.form,
      number = _ref.number,
      expiration = _ref.expiration,
      onChangePaymentMethod = _ref.onChangePaymentMethod,
      cardType = _ref.cardType,
      holder = _ref.holder,
      fieldProps = _ref.fieldProps,
      values = _ref.values;
  var cardFields = [/*#__PURE__*/React.createElement("div", {
    className: cx('new-card-number'),
    key: "new-card-number"
  }, getTextField('cardNumber', _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    mobile: mobile,
    autoComplete: 'cc-number'
  }, mobile ? fieldProps.cardNumber || {} : {}), {}, {
    placeholder: messages.cardNumber
  }, !number ? {
    mask: '9999 9999 9999 9999'
  } : {}), newCard ? {
    validate: cardNumberValidation({
      requiredText: messages.required,
      cardNumberText: messages.cardNumberValidation
    })
  } : {}), number ? {
    disabled: true
  } : {}), {}, {
    disabled: disabled,
    tooltipAbsolute: mobile
  }))), /*#__PURE__*/React.createElement("div", {
    className: cx('new-card-expiration'),
    key: "new-card-expiration"
  }, getTextField('cardExpiration', _objectSpread(_objectSpread({
    autoComplete: 'cc-exp',
    disabled: disabled,
    inputProps: {
      maskChar: null
    },
    mask: '99/99',
    mobile: mobile,
    placeholder: messages.cardExpiration,
    tooltipAbsolute: mobile
  }, newCard ? {
    validate: cardExpirationValidation({
      requiredText: messages.required,
      cardExpirationText: messages.cardExpirationValidation
    })
  } : {}), expiration ? {
    disabled: true
  } : {}))), /*#__PURE__*/React.createElement("div", {
    className: cx('new-card-cvc'),
    key: "new-card-cvc"
  }, getTextField('cvc', _objectSpread({
    autoComplete: 'cc-csc',
    disabled: disabled,
    hideEye: true,
    maxLength: 4,
    mobile: mobile,
    parse: normalizeCVV,
    placeholder: messages.cvc,
    tooltipAbsolute: mobile,
    type: 'password'
  }, !card ? {} : {
    validate: cvcValidation({
      requiredText: mobile ? messages.required : messages.requiredShort,
      isRequired: !(detectCardType(values.cardNumber) === 'mastercard' || cardType.toLowerCase() === 'mastercard')
    })
  }))), /*#__PURE__*/React.createElement("div", {
    className: cx('new-card-holder'),
    key: "new-card-holder"
  }, getTextField('cardHolder', _objectSpread(_objectSpread({
    autoComplete: 'cc-name',
    disabled: disabled,
    mobile: mobile,
    placeholder: messages.cardHolder,
    tooltipAbsolute: mobile
  }, newCard ? {
    validate: cardHolderValidation({
      requiredText: messages.required,
      cardHolderText: messages.cardHolderValidation
    })
  } : {}), holder ? {
    disabled: true
  } : {})))];
  return /*#__PURE__*/React.createElement("div", {
    className: cx('fields')
  }, mobile ? /*#__PURE__*/React.createElement("div", {
    className: cx('new-card')
  }, card && /*#__PURE__*/React.createElement(React.Fragment, null, method === methodType.NEW_CARD && /*#__PURE__*/React.createElement("div", {
    className: cx('row')
  }, getCardIcons()), /*#__PURE__*/React.createElement("div", {
    className: cx('row')
  }, cardFields[0]), /*#__PURE__*/React.createElement("div", {
    className: cx('row')
  }, cardFields[3]), /*#__PURE__*/React.createElement("div", {
    className: cx('row', 'row_vertical_start')
  }, cardFields[1], cardFields[2]))) : card && /*#__PURE__*/React.createElement(React.Fragment, null, cards.length > 0 && cards.map(function (item) {
    return /*#__PURE__*/React.createElement(Card, {
      key: item.id,
      item: item,
      form: form,
      disabled: disabled,
      method: method,
      mobile: mobile,
      themeRadio: themeRadio,
      onChangePaymentMethod: onChangePaymentMethod,
      messages: {
        cvc: messages.cvc,
        required: messages.required,
        requiredShort: messages.requiredShort
      }
    });
  }), /*#__PURE__*/React.createElement("div", {
    className: cx(newCard || cards.length === 0 ? 'new-card' : 'card', {
      'disable-pointer-events': disabled
    }),
    onClick: onChangePaymentMethod(methodType.NEW_CARD, form, disabled),
    role: "button",
    tabIndex: -1
  }, newCard || cards.length === 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cx('row')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('radio')
  }, /*#__PURE__*/React.createElement(Radio, {
    id: methodType.NEW_CARD,
    onChange: onChangePaymentMethod(methodType.NEW_CARD, form, disabled),
    checked: newCard || cards.length === 0,
    theme: themeRadio,
    disabled: disabled
  })), cardFields[0], cardFields[1], cardFields[2]), /*#__PURE__*/React.createElement("div", {
    className: cx('row')
  }, cardFields[3], getCardIcons())) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cx('radio')
  }, /*#__PURE__*/React.createElement(Radio, {
    id: methodType.NEW_CARD,
    onChange: onChangePaymentMethod(methodType.NEW_CARD, form, disabled),
    checked: newCard,
    theme: themeRadio,
    disabled: disabled
  })), /*#__PURE__*/React.createElement(TextBase, {
    size: "l",
    color: "N100",
    as: "span"
  }, messages.newCard)))));
};
Fields.propTypes = process.env.NODE_ENV !== "production" ? {
  mobile: bool,
  disabled: bool,
  cards: array,
  card: bool,
  newCard: bool,
  themeRadio: string,
  method: string,
  form: object,
  onChangePaymentMethod: func,
  number: string,
  expiration: string,
  cardType: string,
  holder: string,
  fieldProps: shape({
    cardNumber: object
  }),
  values: shape({
    cardNumber: string
  }),
  messages: shape({
    newCard: node,
    cvc: node,
    required: node,
    requiredShort: node,
    cardExpiration: node,
    cardExpirationValidation: node,
    cardNumber: node,
    cardNumberValidation: node,
    cardHolder: node,
    cardHolderValidation: node
  })
} : {};